export default function setTrailingZeros(amount: string): string {
  const decimalDigits = 2;
  const amountNumber = Number(amount);

  if (amountNumber % 1 > 0) return amountNumber.toFixed(decimalDigits);

  return Math.floor(amountNumber).toString();
}
